import React, { Component } from 'react';
import './questions.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import activitiesImage from "../static/self1-image.png";
import likeImage from "../static/like.png";
import dislikeImage from "../static/dislike.png";

import {Button} from 'antd';

import Translate from "../translate/Translate";

import {
    questionsList,
    questionsSubmit
} from '../../modules/questions';


class LikeChoices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activitiesData: null,
            loading: false,
            answers: ["","","","","","",""],
        }
    }

    componentDidMount() {
        if (!this.props.questionsData) {
            this.getQuestions();
            // console.log(this.props.questionsData)
        }
    }

    // componentWillMount() {
    //     if (!this.state.activitiesData) {
    //         this.getActivitiesData();
    //     }
    // }

    getQuestions() {
        this.props.questionsList();
    }

    // getActivitiesData() {
    //     this.setState({
    //         activitiesData: {
    //             trad: {
    //                 title: "活動",
    //                 question: "你想參與這個活動嗎？",
    //                 // choices:["素描、繪畫、或描繪", "修理電器", "閱讀科學書籍或雜誌", "與有份量的教育家或治療師會面", "學習商業成功的策略", "填寫詳盡的表格", "使用工具"]
    //             }
    //         }
    //     })
    // }

    radioOnChange(number, status){
        this.setState(state => {
            const answers = state.answers.map(
                (value,i) => {
                    // console.log(number, i,status,value)
                    if(number == i){
                        return status
                    }
                    else{
                        return value
                    }
                }
            );
            return {answers};
        })
        // console.log(this.state.answers)
    }

    actFormSubmit = (event) => {
        this.setState({loading:true});
        event.preventDefault();
        // console.log('Received values of form: ', this.state.answers);
        let resultData= {
            "category": this.props.questionsData.progress,
            "lastQuestionNumber": this.props.questionsData.questions[6].questionNumber,
            "result":{
                "R":0,
                "I":0,
                "A":0,
                "S":0,
                "E":0,
                "C":0,
            }
        }
        this.props.questionsData.questions.map((object,index) => {
            if(this.state.answers[index]){
                resultData.result[object.group]+=1;
                this.state.answers[index]="";
            }
            else{
                this.state.answers[index]="";
            }
        });
        
		this.props.questionsSubmit(resultData).then(
			(res) => {
				if (res) {
					// console.log("success")
				this.setState({loading:false, errormessage:null});
				this.props.formSubmit();
			} else {
			
				this.setState({ loading: false, errormessage: "Something wrong happened, please try again later."});
			}
		},
		(err) => {
			// console.log("error")
			this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
			// this.formRef.current.resetFields();
		}
		);
        this.props.formSubmit();
    }


    render() {
        const data = {
            trad: {
                submit: "下一步"
            }
        };

        const { activitiesData, loading } = this.state;
        // console.log(activitiesData);

        return (
            <div className="formContainer">
                <div className="questionImageContainer activitiesBgColor">
                    <img src={activitiesImage} className="questionImage"></img>
                    <h1><Translate id="questions.activities.title"/></h1>
                </div>
                <div className="questionFormContainer">
                    <form onSubmit={this.actFormSubmit} name="questionsForm">
                        <div className="form lightFont">
                            <div className="radioTitle">
                            <Translate id="questions.activities.description"/>
                            </div>
                            <br></br>
                            {
                                (this.props.questionsData) ?
                                    this.props.questionsData.questions.map(
                                        (item, index) => {
                                            // console.log(item)
                                            if (item.category == "activities")
                                            return(
                                                <div key={index} className="formItem2 darkFont questionsContainer">
                                                    <div className="radioLabel">{item["question_" + this.props.language]}</div>
                                                    <div className="radioItem">
                                                        <input type="radio" name={item.questionNumber + "radio"} id={item.questionNumber + "like"} value="1" onChange={this.radioOnChange.bind(this,index,true)} checked={this.state.answers[index]}/>
                                                        <label htmlFor={item.questionNumber + "like"}  >
                                                            <img src={likeImage} className="radioImage"  />
                                                        </label>
                                                        <input type="radio" name={item.questionNumber + "radio"} id={item.questionNumber+ "dislike"} value="0" required onChange={this.radioOnChange.bind(this,index,false)} checked={(this.state.answers[index]===false)? true: false} />
                                                        <label htmlFor={item.questionNumber + "dislike"} >
                                                            <img src={dislikeImage} className="radioImage" />
                                                        </label>
                                                    </div>
                                                </div>
                                                )
                                        }

                                    )
                                    : null
                            }

                            <div className="submitBtnContainer">
                            <Button htmlType="submit" className="radioSubmitBtn" ><Translate id = "questions.next" /></Button>
                            </div>
                        </div>
                    </form>
                </div>
                {
                  (!this.props.questionsData || loading) &&
                  <div className="loading-screen">
                    <div className="loading-container">
                      <div className="loading-dot class7" />
                      <div className="loading-dot class8" />
                      <div className="loading-dot class9" />
                    </div>
                  </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    questionsData: state.questions.questionsData,
    language: state.mainpage.language
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            questionsList,
            questionsSubmit
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LikeChoices);